import CampaignResult from './CampaignResult';

export default CampaignResult;
